import React from "react";
import { Link} from "react-router-dom";
import Layout from "../Layout/Layout";
import {FaAddressCard, FaMapMarkerAlt, FaUserAlt, FaUserCog, FaBoxes, FaShoppingCart, FaUserSecret, FaMoneyBill, FaHandsHelping , FaPhoneAlt, FaWallet, FaBriefcase} from "react-icons/fa";
import {  MdMessage, MdToday, MdContactPhone, MdAlternateEmail, MdAccountBox} from "react-icons/md";
import { BsGridFill } from "react-icons/bs";
import { GrAscend, GrBusinessService } from "react-icons/gr";
import Table from 'react-bootstrap/Table'
import { Row } from 'react-bootstrap';
import { Family, Adminstrator, Investment, Assoociate, Provider, Seller, Customer, CommercialRole } from "../pageInside/Rolle"
import { laguangeElakay } from "../pageInside/dataElakay";
import { elakayAutoText } from "../pageInside/dataElakay";


const UserAccount = (props) => {
    const {
        infoSource
        } = props

    let userInfo = infoSource.userInfo ? infoSource.userInfo :[]

    // Styles CSS Premium
    const premiumStyles = `
/* ===== ANIMATIONS PREMIUM ===== */
@keyframes accountEnter {
    from {
        opacity: 0;
        transform: translateY(30px) scale(0.97);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes cardStagger {
    from {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes shimmerGlow {
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
}

@keyframes roleBadgeFloat {
    0%, 100% {
        transform: translateY(0) scale(1);
    }
    50% {
        transform: translateY(-3px) scale(1.03);
    }
}

@keyframes iconPulse {
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
}

/* Page animation */
.user-account-premium {
    animation: accountEnter 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

/* ===== CONTAINERS PREMIUM ===== */

.row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"],
.row.mt-4.mb-4.justify-content-center .container[style*="border: 1px solid Gainsboro"] {
    border-radius: 24px !important;
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.95) 0%, 
            rgba(248, 250, 252, 0.98) 100%
        ) !important;
    backdrop-filter: blur(20px);
    box-shadow: 
        0 20px 60px rgba(0, 115, 153, 0.15),
        0 0 0 1px rgba(255, 255, 255, 0.8),
        inset 0 1px 0 rgba(255, 255, 255, 0.6) !important;
    border: 1px solid rgba(226, 232, 240, 0.8) !important;
    overflow: hidden;
    position: relative;
}

/* Shimmer background */
.row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"]::before,
.row.mt-4.mb-4.justify-content-center .container[style*="border: 1px solid Gainsboro"]::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
        circle at center,
        rgba(0, 164, 216, 0.06) 0%,
        transparent 60%
    );
    animation: shimmerGlow 10s linear infinite;
    pointer-events: none;
    z-index: 0;
}

.row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"] > *,
.row.mt-4.mb-4.justify-content-center .container[style*="border: 1px solid Gainsboro"] > * {
    position: relative;
    z-index: 1;
}

/* Header */
.row.mt-4.mb-4.justify-content-center .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] {
    background: 
        linear-gradient(135deg, 
            rgba(0, 115, 153, 0.1) 0%, 
            rgba(0, 164, 216, 0.08) 100%
        ),
        linear-gradient(180deg, 
            rgba(255, 255, 255, 0.9) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        ) !important;
    border-bottom: 2px solid transparent !important;
    border-image: linear-gradient(90deg, 
        transparent 0%, 
        rgba(0, 164, 216, 0.4) 50%,
        transparent 100%
    ) 1 !important;
    padding: 2rem 1rem !important;
}

.row.mt-4.mb-4.justify-content-center .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] h3 {
    background: linear-gradient(135deg, 
        #006b8a 0%, 
        #007399 25%,
        #00a4d8 50%,
        #007399 75%,
        #006b8a 100%
    );
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 800;
    margin: 0;
    animation: shimmerGlow 3s linear infinite;
}

/* ===== INFO USER TABLE ===== */

.table {
    margin-bottom: 0;
}

.table tbody tr {
    border-bottom: 1px solid rgba(226, 232, 240, 0.5);
    transition: all 0.3s ease;
}

.table tbody tr:last-child {
    border-bottom: none;
}

.table tbody tr:hover {
    background: rgba(0, 164, 216, 0.03);
    transform: translateX(5px);
}

.table td {
    padding: 1.25rem 0.5rem;
    border: none;
}

.table td h4,
.table td h5 {
    margin: 0;
    color: #1e293b;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.table td span[style*="fontSize: 30px"] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    background: linear-gradient(135deg, 
        rgba(224, 242, 254, 0.8) 0%, 
        rgba(219, 234, 254, 0.8) 100%
    );
    border-radius: 50%;
    color: #007399 !important;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.table tbody tr:hover td span[style*="fontSize: 30px"] {
    transform: scale(1.1) rotate(5deg);
    background: linear-gradient(135deg, 
        rgba(0, 164, 216, 0.2) 0%, 
        rgba(0, 115, 153, 0.2) 100%
    );
    box-shadow: 0 4px 12px rgba(0, 115, 153, 0.2);
}

/* ===== ROLE BADGE ===== */

.row.mt-4.mb-4.justify-content-center .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] span {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background: linear-gradient(135deg, #38bdf8 0%, #0ea5e9 100%);
    color: #ffffff;
    padding: 0.5rem 1rem;
    border-radius: 16px;
    font-size: 0.875rem;
    font-weight: 700;
    box-shadow: 0 4px 12px rgba(56, 189, 248, 0.3);
    animation: roleBadgeFloat 2s ease-in-out infinite;
    margin-left: 0.75rem;
}

/* ===== MENU CARDS ===== */

.user-account-premium .card {
    border-radius: 20px;
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.98) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        );
    backdrop-filter: blur(10px);
    border: 1px solid rgba(226, 232, 240, 0.6);
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 
        0 4px 16px rgba(0, 115, 153, 0.08),
        0 0 0 1px rgba(255, 255, 255, 0.5),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
    position: relative;
    height: 100%;
}

.user-account-premium .card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgba(0, 164, 216, 0.05) 0%, 
        transparent 50%
    );
    opacity: 0;
    transition: opacity 0.4s ease;
    pointer-events: none;
}

.user-account-premium .card:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 
        0 20px 40px rgba(0, 115, 153, 0.2),
        0 0 0 1px rgba(0, 164, 216, 0.3),
        0 0 60px rgba(0, 164, 216, 0.1);
    border-color: rgba(0, 164, 216, 0.4);
}

.user-account-premium .card:hover::before {
    opacity: 1;
}

/* Card Body */
.user-account-premium .card-body {
    padding: 2rem 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.user-account-premium .card-title {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, 
        rgba(224, 242, 254, 0.8) 0%, 
        rgba(219, 234, 254, 0.8) 100%
    );
    border-radius: 50%;
    color: #007399;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 0 4px 12px rgba(0, 115, 153, 0.15);
}

.user-account-premium .card:hover .card-title {
    transform: scale(1.15) rotate(10deg);
    background: linear-gradient(135deg, 
        rgba(0, 164, 216, 0.2) 0%, 
        rgba(0, 115, 153, 0.2) 100%
    );
    box-shadow: 0 8px 24px rgba(0, 115, 153, 0.3);
    animation: iconPulse 1s ease-in-out infinite;
}

/* Card Footer */
.user-account-premium .card-footer {
    background: 
        linear-gradient(135deg, 
            rgba(0, 115, 153, 0.05) 0%, 
            rgba(0, 164, 216, 0.03) 100%
        );
    border-top: 1px solid rgba(226, 232, 240, 0.6);
    padding: 1rem;
    color: #1e293b;
    font-weight: 600;
    font-size: 0.9375rem;
    transition: all 0.3s ease;
}

.user-account-premium .card:hover .card-footer {
    background: 
        linear-gradient(135deg, 
            rgba(0, 115, 153, 0.1) 0%, 
            rgba(0, 164, 216, 0.08) 100%
        );
    color: #007399;
}

/* Cards Stagger Animation */
.user-account-premium .col {
    animation: cardStagger 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

.user-account-premium .col:nth-child(1) { animation-delay: 0.05s; }
.user-account-premium .col:nth-child(2) { animation-delay: 0.1s; }
.user-account-premium .col:nth-child(3) { animation-delay: 0.15s; }
.user-account-premium .col:nth-child(4) { animation-delay: 0.2s; }
.user-account-premium .col:nth-child(5) { animation-delay: 0.25s; }
.user-account-premium .col:nth-child(6) { animation-delay: 0.3s; }
.user-account-premium .col:nth-child(7) { animation-delay: 0.35s; }
.user-account-premium .col:nth-child(8) { animation-delay: 0.4s; }
.user-account-premium .col:nth-child(9) { animation-delay: 0.45s; }
.user-account-premium .col:nth-child(10) { animation-delay: 0.5s; }
.user-account-premium .col:nth-child(11) { animation-delay: 0.55s; }
.user-account-premium .col:nth-child(12) { animation-delay: 0.6s; }

/* ===== LINKS ===== */

.user-account-premium a {
    text-decoration: none;
    color: inherit;
    display: block;
}

/* ===== RESPONSIVE ===== */

@media (max-width: 768px) {
    .row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"],
    .row.mt-4.mb-4.justify-content-center .container[style*="border: 1px solid Gainsboro"] {
        border-radius: 20px !important;
    }

    .row.mt-4.mb-4.justify-content-center .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] {
        padding: 1.5rem 1rem !important;
    }

    .table td {
        padding: 1rem 0.25rem;
    }

    .table td span[style*="fontSize: 30px"] {
        width: 45px;
        height: 45px;
    }

    .user-account-premium .card-body {
        padding: 1.5rem 0.75rem;
    }

    .user-account-premium .card-title {
        width: 70px;
        height: 70px;
    }

    .user-account-premium .card-footer {
        padding: 0.875rem;
        font-size: 0.875rem;
    }
}

/* ===== REDUCED MOTION ===== */

@media (prefers-reduced-motion: reduce) {
    .user-account-premium,
    .user-account-premium .col,
    .user-account-premium .card,
    .table tbody tr,
    .row.mt-4.mb-4.justify-content-center .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] h3,
    .row.mt-4.mb-4.justify-content-center .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] span {
        animation: none !important;
        transition: none !important;
    }
}
`;

    let styleText ={ fontSize: 'clamp(0.8rem, 2.5vw, 1.2rem)', margin: 0 }

    let colClass ="col p-1"
    const roleUser =()=>(
        <>
           {
        Customer(true) && (
                     <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).royalty}</span>
                )}
        {
        Seller(true) && (
             <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).seller}</span>
        )}
         { Provider(true) && (
             <h4>{infoSource.laguangeElakay('title', infoSource.languageAPI).provider}</h4>
        )}
           {
        Assoociate(true) && (
             <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).assoociate}</span>
        )}   {
        Investment(true) && (
            <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).investment}</span>
            )}
       {Adminstrator(true) && (
            <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).Admin}</span>
        )}
        {Family() && (
            <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).family}</span>
        )}
        </>
    )
    let telephone =  infoSource.phoneUser && infoSource.phoneUser.filter(k => k.default === true)[0]
    let AddressTrue  = infoSource.address && infoSource.address.filter(k => k.addressDefault === true)[0]

    const infoUser = (
        <div className="row mt-4 mb-4 justify-content-center">
            <style>{premiumStyles}</style>
            <div className="col col-12 col-md-10 col-lg-8 col-xl-6 p-0" style={{ border: "1px solid Gainsboro" }} >
                <div className="col col-12 col-md-12" style={{ textAlign: "center", backgroundColor: "WhiteSmoke" }}>
                    <h3>{infoSource.laguangeElakay('title', infoSource.languageAPI).yourInfo}  {roleUser()}</h3>
                </div>
                <div className="m-3">
               
                <Table>
                <tbody>
                    <tr>
                        <td><h4><span style={{ fontSize: "30px", paddingRight: "20px" }}><FaUserAlt /></span>  {`${userInfo.firstname} ${userInfo.lastname}`} </h4></td>
                    </tr>
                    <tr>
                        <td><h5><span style={{ fontSize: "30px", paddingRight: "20px" }}><MdAlternateEmail /></span>{userInfo.email} </h5></td>
                    </tr>
                    
                    {    telephone &&   <tr><td>
                    <div>
                                <h5>
                                 <FaPhoneAlt /> {telephone.International}
                                </h5>
                            </div>
                            </td></tr>}
                   {AddressTrue &&  <tr><td>
                                <h5><span> <FaMapMarkerAlt />  { AddressTrue.firstName} {AddressTrue.lastName}</span> <br /> <span style={{ paddingLeft: "20px" }}>  {AddressTrue.Address1}, {AddressTrue.city} {AddressTrue.State} {AddressTrue.postalCode} {AddressTrue.country}</span> <br />
                                    <span style={{ paddingLeft: "21px", fontSize: "14px" }}> {infoSource.laguangeElakay('title', infoSource.languageAPI).defaultDeliryAdress}</span>
                                </h5>
                                </td></tr>}
                    </tbody>
                </Table>
            </div></div>
        </div>
    ) 


    const menu = (
        <div className="row mt-4 mb-4 justify-content-center user-account-premium">
            <div className="container p-0" style={{ border: "1px solid Gainsboro" }} >
                <div className="col col-12 col-md-12" style={{ textAlign: "center", backgroundColor: "WhiteSmoke" }}>
                    <h3>{infoSource.laguangeElakay('title', infoSource.languageAPI).menu}</h3>
                </div>
                <div className="container-fluid">
                    <Row xs={2} sm={2} md={3} lg={3} xl={3}>

                    {    CommercialRole() &&  <div className={colClass}>
                        <Link to="/user-setting">
                            <div className="card">
                                <div className="card-body mx-auto">
                                    <span className="card-title" style={{ fontSize: "50px" }}> <FaUserCog /></span>
                                </div>
                                <div className="card-footer text-center"  style={styleText} >{infoSource.laguangeElakay('menuList', infoSource.languageAPI).userSetting}</div>
                            </div>
                        </Link>
                        </div>}

                        <div  className={colClass}>
                            <Link to="/all-catageories">
                            <div className="card">
                                
                                <div className="card-body mx-auto">
                                    <span className="card-title" style={{ fontSize: "50px" }}> <BsGridFill /></span>
                                </div>
                                <div className="card-footer text-center"  style={styleText} >{infoSource.laguangeElakay('menuList', infoSource.languageAPI).allCategory}</div>
                           
                            </div> </Link>

                        </div>
                       
                        <div  className={colClass}>
                            <Link to="/your-step">
                            <div className="card">
                                
                                <div className="card-body mx-auto">
                                    <span className="card-title" style={{ fontSize: "50px" }}> <GrAscend /></span>
                                </div>
                                <div className="card-footer text-center"  style={styleText} >{infoSource.laguangeElakay('menuList', infoSource.languageAPI).yourStep}</div>
                           
                            </div> </Link>

                        </div>
                        <div className={colClass}>
                        <Link to="/profile">
                            <div className="card">
                                <div className="card-body mx-auto">
                                    <span className="card-title" style={{ fontSize: "50px" }}> <FaUserSecret /></span>
                                </div>
                                <div className="card-footer text-center"  style={styleText} >{infoSource.laguangeElakay('menuList', infoSource.languageAPI).myProfile}</div>
                            </div>
                        </Link>
                        </div>

                        <div className={colClass}>
                        <Link to="/account">
                            <div className="card">
                                <div className="card-body mx-auto">
                                    <span className="card-title" style={{ fontSize: "50px" }}> <MdAccountBox /></span>
                                </div>
                                <div className="card-footer text-center"  style={styleText} >{infoSource.laguangeElakay('menuList', infoSource.languageAPI).myAccount}</div>
                            </div>
                        </Link>
                        </div>

                        <div className={colClass}>
                        <Link to="/profile?addr=true">
                            <div className="card">
                                <div className="card-body mx-auto">
                                    <span className="card-title" style={{ fontSize: "50px" }}> <FaAddressCard /></span>
                                </div>
                                <div className="card-footer text-center"  style={styleText} >{infoSource.laguangeElakay('Button', infoSource.languageAPI).addAdress}</div>
                            </div>
                        </Link>
                        </div>

                    <div className={colClass}>
                        <Link to="/profile?tel=true">
                            <div className="card">
                                <div className="card-body mx-auto">
                                    <span className="card-title" style={{ fontSize: "50px" }}> <MdContactPhone/></span>
                                </div>
                                <div className="card-footer text-center"  style={styleText} >{infoSource.laguangeElakay('Button', infoSource.languageAPI).addTel}</div>
                            </div>
                        </Link>
                    </div>
                        
                        <div className={colClass}>  
                        <Link to="/c/orders">
                            <div className="card">
                                <div className="card-body mx-auto">
                                    <span className="card-title" style={{ fontSize: "50px" }}> <FaBoxes /></span>
                                </div>
                                <div className="card-footer text-center"  style={styleText} >{infoSource.laguangeElakay('menuList', infoSource.languageAPI).myOrders}</div>
                            </div>
                        </Link>
                        </div> 
                        <div className={colClass}>
                        <Link to="/cart">
                            <div className="card">
                                <div className="card-body mx-auto">
                                    <span className="card-title" style={{ fontSize: "50px" }}> <FaShoppingCart /></span>
                                </div>
                                <div className="card-footer text-center"  style={styleText} >{infoSource.laguangeElakay('menuList', infoSource.languageAPI).myCart}</div>
                            </div>
                        </Link>
                        </div>
                        <div className={colClass}>
                        <Link to="/deal-today">
                            <div className="card">
                                <div className="card-body mx-auto">
                                    <span className="card-title" style={{ fontSize: "50px" }}> <MdToday /></span>
                                </div>
                                <div className="card-footer text-center"  style={styleText} >{infoSource.laguangeElakay('menuList', infoSource.languageAPI).todayDeal}</div>
                            </div>
                        </Link>
                        </div>
                        <div className={colClass}>
                        <Link to="/help-contact">
                            <div className="card">
                                <div className="card-body mx-auto">
                                    <span className="card-title" style={{ fontSize: "50px" }}> <FaHandsHelping /></span>
                                </div>
                                <div className="card-footer text-center"  style={styleText} >{infoSource.laguangeElakay('menuList', infoSource.languageAPI).helpContact}</div>
                            </div>
                        </Link></div>
                        <div className={colClass}>
                        <Link to="/purchased">
                            <div className="card">
                                <div className="card-body mx-auto">
                                    <span className="card-title" style={{ fontSize: "50px" }}> <FaMoneyBill /></span>
                                </div>
                                <div className="card-footer text-center"  style={styleText} >{infoSource.laguangeElakay('menuList', infoSource.languageAPI).myPurchased}</div>
                            </div>
                        </Link>
                        </div>

                        <div className={colClass}>
                        <Link to="/wallet">
                            <div className="card">
                                <div className="card-body mx-auto">
                                    <span className="card-title" style={{ fontSize: "50px" }}> <FaWallet /></span>
                                </div>
                                <div className="card-footer text-center"  style={styleText} >{infoSource.laguangeElakay('menuList', infoSource.languageAPI).wallet}</div>
                            </div>
                        </Link>
                        </div>

                        <div className={colClass}>
                        <Link to="/message">
                            <div className="card">
                                <div className="card-body mx-auto">
                                    <span className="card-title" style={{ fontSize: "50px" }}> <MdMessage /></span>
                                </div>
                                <div className="card-footer text-center"  style={styleText} >{infoSource.laguangeElakay('menuList', infoSource.languageAPI).myMessage}</div>
                            </div>
                        </Link>
                        </div>

                        <div className={colClass}>
                        <Link to="/my-job-applications">
                            <div className="card">
                                <div className="card-body mx-auto">
                                    <span className="card-title" style={{ fontSize: "50px" }}> <FaBriefcase /></span>
                                </div>
                                <div className="card-footer text-center"  style={styleText} >{infoSource.laguangeElakay('menuList', infoSource.languageAPI)?.myJobApplications || elakayAutoText("h_nav_my_job_applications", "Mes candidatures")}</div>
                            </div>
                        </Link>
                        </div>
                 </Row>
                </div>
            </div>
        </div>
    )

    return (
        <Layout
        infoSource ={infoSource}
            title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).userAccount.t001}
            description={elakayAutoText("h_41682905073222", "Node React E-commerce App")}
            className="container-fluid"
            SliderPunShow={false}
            loading={false}
            {...infoSource?.allSettings?.layout}
        >
        <div style={infoSource.styleNav}>
            {infoUser}
            {menu}
           </div>
        </Layout>
    );
};

export default UserAccount;
